import React from "react";

const IconBadge = ({ Icon, tooltip }) => {
  if (!Icon) return null;

  const label = tooltip || "";
  const tabIndex = label ? 0 : -1;

  return (
    <span
      className="icon-badge"
      data-tooltip={label}
      aria-label={label || undefined}
      tabIndex={tabIndex}
    >
      <Icon />
    </span>
  );
};

export default IconBadge;

